<template>
  <el-dialog
    title="导出打卡记录"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form
        :inline="true"
        label-position="left"
        class="demo-form-inline"
        :model="form"
        ref="demoref"
      >
        <el-form-item
          label="打卡时间"
          prop="valueTime"
        >
          <el-date-picker
            v-model="form.valueTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="用户姓名">
          <el-input v-model="form.username" placeholder="请输入用户姓名"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button
        type="primary"
        @click="addOrUpdateFun()"
        :loading="exportLoading"
        >导 出</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import {
  dutyLogExp,
} from "@/api/onDutyAndStandBy.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    sourceMangerId: {
      type: [String,Number],
      default: ''
    },
  },
  data() {
    return {
      form: {
        valueTime: [],
        username: ''
      },
      exportLoading: false
    };
  },
  methods: {
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async addOrUpdateFun() {
      this.exportLoading = true;
      let res = await dutyLogExp({
        logTimeStart: this.form.valueTime && this.form.valueTime.length ? `${this.form.valueTime[0]} 00:00:00` : '',
        logTimeEnd: this.form.valueTime && this.form.valueTime.length ? `${this.form.valueTime[1]} 23:59:59` : '',
        username: this.form.username,
        ghEventTypeId: "id_zhishou",
        typeSource: "事项管理",
        sourceMangerId: this.sourceMangerId
      });
      if (res.status == 200) {
        this.handleClose();
        this.exportLoading = false;
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "值守记录" + new Date().getTime() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 10px 20px;
}

/deep/.el-input {
  width: auto !important;
}
/deep/.el-dialog {
  margin-top: 16vh !important;
}
.flex {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/standBy/components/dakaDialog.vue